"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Chip = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Chip = ({ children, onPress }) => {
    return ((0, jsx_runtime_1.jsx)("a", { className: "btn btn-outline-dark small py-0 rounded-pill px-2", onClick: onPress, children: children }));
};
exports.Chip = Chip;
